import {
  CLEAR_COLABORADORES_ACTION,
  FETCH_COLABORADORES,
  FETCH_COLLABORATOR_INFO,
  SEND_COLLABORATOR,
  SEND_FILES,
  SEND_CAPTURES,
  SEND_SIGNATURES,
  SEND_FINGERPRINTERS,
} from './actions.type';

import {
  SET_ERROR,
  CLEAR_COLABORADORES,
  FETCHED_COLABORADORES,
  FETCHING_COLABORADORES,
  CLEAR_COLLABORATOR_INFO,
  SET_COLLABORATOR,
  FETCHING_COLLABORATOR,
  FETCHED_COLLABORATOR,
  SUBMITED_COLABORADOR,
  SUBMIT_COLABORADOR_ERROR,
  RESET_COLABORADOR_SUBMIT,
  SUBMIT_FILES_ERROR,
  SUBMITTED_FILES,
  SUBMIT_CAPTURES_ERROR,
  SUBMITTED_CAPTURES,
  SUBMITTED_SIGNATURES,
  SUBMIT_SIGNATURES_ERROR,
  SUBMITTED_FINGERPRINTERS,
  SUBMIT_FINGERPRINTERS_ERROR,
  CLEAR_FINGERPRINTERS,
  CLEAR_CAPTURES,
  CLEAR_ALERT_DIALOG,
  RESET_COLABORADOR_PROCESSING,
  STARTED_COLABORADOR_PROCESSING,
  SET_COLLABORATOR_CREDENTIAL,
  GENERATE_CREDENTIAL,
  CLEAR_COLABORADOR_CREDENCIAL,
} from './mutations.type';
import ApiService from '../common/api.service';

/* eslint-disable no-param-reassign */
/* eslint-disable no-shadow */

const state = {
  alert: false,
  alertMessage: '',
  alertType: 'success',
  alertDialog: false,
  alertDialogMessage: '',
  alertDialogType: 'success',
  loading_colaboradores: false,
  processing_colaborador: false,
  loading_collaborator: false,
};

const getters = {
  is_loading() {
    return state.loading_colaboradores;
  },
  alertContainer(state) {
    return state.alert;
  },
  alertContainerMessage(state) {
    return state.alertMessage;
  },
  alertContainerType(state) {
    return state.alertType;
  },
  alertDialog(state) {
    return state.alertDialog;
  },
  alertDialogMessage(state) {
    return state.alertDialogMessage;
  },
  alertDialogType(state) {
    return state.alertDialogType;
  },
  colaborador_processing() {
    return state.processing_colaborador;
  },
};

const actions = {
  [FETCH_COLLABORATOR_INFO](context, collaboratorId) {
    return new Promise((resolve) => {
      ApiService.setHeader();
      context.commit(FETCHING_COLLABORATOR);
      const url = `censos/colaborador/${collaboratorId}`;
      ApiService.query(url)
        .then(({ data }) => {
          context.commit(FETCHED_COLLABORATOR);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(SET_ERROR, [response.data.message]);
          context.commit(FETCHED_COLLABORATOR);
        });
    });
  },
};

const mutations = {
  [FETCHING_COLLABORATOR](state) {
    state.loading_collaborator = true;
  },
  [FETCHED_COLLABORATOR](state) {
    state.loading_collaborator = false;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
